import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const pet_insurance_cancelled = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('cancelled_by_previous_insurer')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_insurance_cancelled.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
      valueToStepName: {
        true: 'failure',
        false: 'pet_treatment',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pet_insurance_cancelled
